module.exports = __webpack_public_path__ + "static/260824_HSE - Material Differences Report_30.6.26-338906348e53831a46d391445d3b2291.pdf";